import { useTranslations } from 'next-intl'
import { useEffect } from 'react'

import { useInitGlobalStore } from '@/stores/global'

export default function useAppInit() {
  useInitGlobalStore()
  useMountGlobalTranslator()
  return null
}

/**
 * Mount the global translator (t function) to the window object for using outside of React
 */
function useMountGlobalTranslator() {
  const t = useTranslations()

  useEffect(() => {
    window.cdcMarketTranslator = t
  }, [t])
}
